import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsFirstPreviewTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_FIRST_PREVIEW;

	get id(): string {
		return TourId.REPORTS__FIRST_PREVIEW;
	}

	override get keyForPersistantDone(): string {
		return ReportsFirstPreviewTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				allowStacked: false,
				attachTo: () => {
					return this.el?.find('.overlay .previewbutton') || null;
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
